// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-contaier[data-v-a221d61e]{overflow:hidden;position:relative}", "",{"version":3,"sources":["webpack://./resources/assets/js/pages/Dashboard/Report.vue"],"names":[],"mappings":"AAAA,kCAEE,eAAgB,CADhB,iBACkB","sourcesContent":[".report-contaier {\n  position: relative;\n  overflow: hidden; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
